export default function SiteHeader() {
  return (
    <header className="site-header">
      <div className="site-header-inner">
        {/* Logo links to the main marketing site, not this scorecard's own
            landing page — each scorecard slug is a lead-magnet, not "home". */}
        <a href="https://goodwingsolutions.com" aria-label="Goodwing Solutions">
          <img src="/logo.png" alt="Goodwing Solutions" />
        </a>
        {/* Right-hand CTA slot — left intentionally empty for now. */}
        <div className="site-header-actions" />
      </div>
    </header>
  );
}
